import React from 'react';
import cls from './Divider.module.css';
import cn from 'classnames';

interface DividerProps {
    classes?: string;
}

export const Divider = ({ classes = '' }: DividerProps) => {
    return <span className={cn(cls.Divider, [classes])}></span>;
};
